import Vue from 'vue'
import router from './router/router'
import store from './store/store'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

Vue.use(Vuex);

/*
import VueAnalytics from 'vue-analytics';
// Configuration VueAnalytics
if (process.env.NODE_ENV === 'production' || process.env.VUE_APP_SANDKASTENLIGA_GA_TEST) {
    Vue.use(VueAnalytics, {
        id: 'UA-126160-3',
        router,
        autoTracking: {
            exception: true,
            pageviewTemplate(route) {
                return {
                    page: route.name,
                    title: document.title,
                    location: window.location.href
                }
            }
        },
        trackEvent: true
    });
    window.console.log("Google Analytics turned on.")
}
 */

import './plugins/vue-fontawesome'
import 'vue-slider-component/theme/antd.css'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents);

import VueMq from 'vue-mq'

Vue.use(VueMq, {
    breakpoints: {
        mobile: 450,
        tablet: 768,
        laptop: 1250,
        desktop: Infinity,
    }
})
// Cloudinary
import Cloudinary from 'cloudinary-vue';

Vue.use(Cloudinary, {
    configuration: {
        cloudName: "sandkastenliga"
    }
});

// moment.js
import moment from 'moment'
import 'moment/locale/de';

moment.locale('de');

import './assets/global.css'

import Vuex from "vuex";

import baseUrl from './mixins/base-url'

Vue.mixin(baseUrl);

import utils from './mixins/util'

Vue.mixin(utils);

Vue.filter('calendar', function (date) {
    return moment(date).calendar(null, {
        sameElse: 'DD.MM. HH:mm'
    })
});

Vue.filter('shortTime', function (date) {
    return moment(date).format('HH:mm')
});

Vue.filter('shortDate', function (date) {
    return moment(date).format('DD.MM.')
});

Vue.filter('kies', function (k) {
    return '₭' + Math.floor(k).toLocaleString("de-DE")
});

Vue.filter('float', function (p) {
    if (!p)
        return 0.0;
    return p.toFixed(1).toLocaleString()
});

Vue.filter('int', function (p) {
    if (!p)
        return 0;
    return Math.floor(p)
});

Vue.filter('challenge', function (c) {
    return c.split('/', 2)[1]
});


Vue.filter('pos', function (p) {
    if (p === 'GOAL')
        return 'Tor';
    if (p === 'DEFENSE')
        return 'Abwehr';
    if (p === 'MIDFIELD')
        return 'Mittelfeld';
    if (p === 'ATTACK')
        return 'Sturm';
    return '?'
});

// global Vue stuff
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm, info) {
    console.log(`Vue errorHandler: ${err.toString()}\nInfo: ${info}`);
    vm.$store.dispatch('messageAction', {
        type: 'danger',
        message: 'Ein Fehler ist aufgetreten. Bitte lade die Seite neu und versuche es noch einmal!'
    })
};

// global Sakali components
import TeamEmblem from "./components/global/TeamEmblem";

Vue.component('team-emblem', TeamEmblem);

import User from "./components/global/User";
Vue.component('sakali-user', User);

import Heading from "./components/global/Heading";

Vue.component('sakali-header', Heading);

import AsyncComputed from "vue-async-computed";

Vue.use(AsyncComputed)

import MessagesMixin from "@/mixins/MessagesMixin";

Vue.mixin(MessagesMixin)

import sakaliApi from './sakali-api'

Vue.prototype.$api = sakaliApi

import vueDebounce from 'vue-debounce'

Vue.use(vueDebounce)

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {};
Vue.use(Toast, options);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
